/// <reference path="../../../_Ext/Bases/GridBase.ts" />
namespace TabAurous.Common {

    @Serenity.Decorators.registerClass()
    export class ProcessQISelectGrid extends _Ext.GridBase<OMS.ProcessInspectionRow, any> {
        protected getColumnsKey() { return 'OMS.ProcessInspection'; } 
        protected getIdProperty() { return OMS.ProcessInspectionRow.idProperty; }
        protected getLocalTextPrefix() { return OMS.ProcessInspectionRow.localTextPrefix; }
        protected getService() { return OMS.ProcessInspectionService.baseUrl; }
        //protected useViewMode() { return true; }
    

        constructor(container: JQuery, options) {
            super(container, options); 
            new Serenity.HeaderFiltersMixin({
                grid: this
            });

            this.slickGrid.setOptions({ rowHeight: 30 }); 
            return this;
        }

        private autoSize;

        protected createSlickGrid(): Slick.Grid {
            let grid = super.createSlickGrid();
            this.autoSize = new Slick.AutoColumnSize(); // *** If you want to make it autoresize when grid is loaded, use: new Slick.AutoColumnSize(true);
            grid.registerPlugin(this.autoSize); 
            return grid;
        }

        protected createToolbarExtensions(): void {
            super.createToolbarExtensions()

        }
        protected getViewOptions() {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            return opt;
        }
        // *** Resizes the columns after changes are made to the grid (ex. Column Picker) *
        protected markupReady() {
            super.markupReady();
            if (this.autoSize != null) {
                this.autoSize.resizeAllColumns();
            }
        }

        get selectedItems(): OMS.ProcessInspectionRow[] {
            var _this = this;
            var selecteditems = this.rowSelection.getSelectedAsInt32().map(function (x) { return _this.view.getItemById(x); });
            if (selecteditems.length != 1) {
                q.alert('', 'Only one template can be selected', true, 2999);
                return [];
            }
            return selecteditems;
        }

        protected usePager() { return true; };
        protected getInitialTitle() { return null; };

        protected getButtons() {
            var buttons = super.getButtons.call(this);
            buttons = buttons.filter(function (x) { return x.cssClass != 'add-button'; });
            return buttons;
        };

        protected onViewSubmit() {

            if (!super.onViewSubmit.call(this))
                return false;
             return true;
        }

    } 
}